import { recentOrdersStatusSx } from '@/components/content/Header/parts/HDMMyRecentOrders/styles/Status';
import { EMPTY_STRING } from '@/data/constants/order';
import { useOrderHistoryStatus } from '@/data/Content/HdmOrderHistoryStatus';
import { Stack } from '@mui/material';
import Typography from '@mui/material/Typography';

export const MyRecentOrderStatus = ({ orderId }: { orderId: string }) => {
	const { orderStatusHistory } = useOrderHistoryStatus(orderId);
	const status = orderStatusHistory?.statusData?.status || EMPTY_STRING;
	return (
		<Stack sx={{ borderRadius: '3px', overflow: 'hidden' }}>
			<Typography variant="bodyBaseline" sx={recentOrdersStatusSx(status)}>
				{status}
			</Typography>
		</Stack>
	);
};
